import { Component, OnInit } from '@angular/core';
import { ForgotPasswordService } from '../../services/ForgotPassword.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  isSubmitError: boolean = false;
  isSubmitSuccess: boolean = false;
  errorMessage: string = '';
  loader: boolean = false;
  submit: boolean = false;
  isPanelSelected: boolean = true;
  panel: string = null;
  constructor(private forgotService: ForgotPasswordService) { }

  ngOnInit() {

  }

  selectPanel(value) {

    this.isPanelSelected = value != "null" ? true : false;
  }

  onSubmit(forgotPasswordForm) {
    this.loader = true;
    if (forgotPasswordForm.value.panel == "null" || forgotPasswordForm.value.panel == undefined) {
      this.isPanelSelected = false;
      this.loader = false;

    }
    else {
      this.forgotService.forgotPasswordCheck(forgotPasswordForm.value.username, forgotPasswordForm.value.email, forgotPasswordForm.value.panel).subscribe(
      (data) => {
        forgotPasswordForm.reset();
        this.isSubmitSuccess = true;
        this.isSubmitError = false;
        this.errorMessage = data["StatusMessage"];
        AlertMessages.Show('Success','Password Sent!', AlertType.Success);

     },
     (error) => {
         this.isSubmitError = true;
          this.isSubmitSuccess = false;
       this.errorMessage = error.error[0];
       AlertMessages.Show('Failed',error.error[0], AlertType.Error);

     }).add(() => {
       this.loader = false;
     });
    }
  }


}
